module.exports = __webpack_public_path__ + "assets/img/logo.962f3b61.png";